module.exports = __webpack_public_path__ + "static/media/arrows-blue.10266852.svg";